import _get from 'lodash/get';
import { fetchSignedUpload, createSourceFile } from 'store/sources';

interface Props {
  file: any;
  sourceId: string;
  isActive?: boolean;
  dispatch: (fetchFunction: any) => void;
}

async function uploadCsvFile({ file, sourceId, isActive = true, dispatch }: Props) {
  const signedUploadResponse = await dispatch(
    fetchSignedUpload({
      name: file.name,
      contentType: 'text/csv',
      size: file.size,
      sourceId,
    }),
  );

  const signedUpload = _get(signedUploadResponse, 'body');

  await fetch(signedUpload.url, {
    method: 'PUT',
    mode: 'cors',
    headers: {
      ...signedUpload.fields,
      Accept: `${signedUpload.fields['Content-Type']}`,
    },
    body: file,
  });

  const sourceFileResponse = await dispatch(
    createSourceFile({
      sourceId,
      key: signedUpload.key,
      size: file.size,
      contentType: 'text/csv',
      name: file.name,
      isActive,
    }),
  );

  const sourceFile = _get(sourceFileResponse, 'body');

  return sourceFile;
}

export default uploadCsvFile;
